<template>
    <div class="SX">
       <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">首页></span>
        <span @click="GoSiXiang">巡视巡察></span>
          <span @click="GoBJ">北京动态></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
    <div class="zhengwen">
      <h1>省司法厅：召开2018年度第二轮巡察情况汇报会</h1>
      <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
      <div class="second">
        <p>日前，省司法厅党委书记、厅长姜明专题听取厅党委2018年度第二轮巡察情况汇报，研究部署下一阶段工作。驻厅纪检监察组组长、厅党委委员胡之春，厅党委委员、副厅长黄冰霓出席会议。</p>

        <strong><p>　</p></strong>

        <p>会议对本轮巡察工作取得的成绩给予充分肯定并指出，2个巡察组按照厅党委的部署要求，突出政治巡察，坚持问题导向，对被巡察单位进行了全面深入的监督检查，情况掌握透彻，问题发现精准，圆满完成了巡察任务。从发现的问题来看，既有基层单位的个性问题，也有许多系统内的共性问题，需要引起高度重视并切实加以解决。</p>

        <p>会议强调，要研究完善巡察工作领导体制。在巡察实践中总结提升，完善体制机制，在对基层监所单位的巡察中，充分发挥主管局党委在整改落实中的作用，着力形成厅党委、主管局党委、被巡察单位党委三级联动的巡察工作格局，推动压力有效传导，确保巡察链式推进，取得更好成效。要压紧压实巡察整改责任。巡察发现的问题要逐条逐项梳理，建立问题清单、任务清单、责任清单。厘清主管局、被巡察单位各自责任，在向被巡察单位反馈的同时，向其主管局通报情况，交办整改任务。尤其是对一些重点领域存在的共性问题，主管局要站位系统全局，坚持举一反三，深化标本兼治，通过健全制度规定、加强日常监督管理等方式，着力形成解决问题和推动工作的长效机制。 </p>
          <strong><p>　 </p></strong>

        <p>会议要求，要认真开展巡察反馈整改。按照巡察工作程序，由厅领导分别带队进行反馈，原原本本传达厅党委要求。被巡察单位要认真对待巡察反馈意见，强化问题整改的政治担当，对照问题清单，制定整改方案，对能够立即解决的，要即知即改、立行立改，需要进一步研究的，要明确整改措施、时限和责任，确保整改不拖延、不打折。对巡察中发现的党员干部问题线索，要按照相关规定和程序认真分析研判，确保查清核实，依规依纪严肃处置。</p>

        <p>会上通报了2017年巡察发现问题线索的处理情况，对巡察反馈工作进行了安排部署。（驻省司法厅纪检监察组</p>
      </div>
    </div>
      
    
    </div>


    </div>
</template>
<script>
export default {
    methods: {
         GoRisk() {
      this.$router.push("/HOME");
    },
   GoSiXiang() {
      this.$router.push("/MakeInspectionTour");
    },
    GoBJ() {
      this.$router.push("/MakeInspectionTour/BeiJing");
    },
    },
    
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.si{
   margin: 0 16px;
 }
</style>